import { Component, inject, Input } from "@angular/core";
import { NavigationService } from "src/app/services/navigation/navigation.service";
import { BRAND, DEMO } from "src/app/config/brand.config";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent {
  @Input() appFooterContainerCSSClass: string = "";
  @Input() displaySection: "full" | "contact" | "copyright" = "full";

  #scrollService = inject(NavigationService);

  /**
   * The two link columns. Short on purpose: a footer sitemap of everything is a
   * list nobody reads, whereas four destinations a visitor might actually want
   * at the bottom of a page is navigation.
   */
  exploreLinks: FooterLink[] = [
    { label: "MENU.COURSES", route: "/courses" },
    { label: "MENU.BLOG", route: "/blogs" },
    { label: "MENU.MANUAL", route: "/manual" },
  ];

  companyLinks: FooterLink[] = [
    { label: "MENU.ABOUT_US", route: "/about-us" },
    { label: "MENU.HOME", route: "/" },
  ];

  /**
   * The policy pages, on their own row in the bottom bar rather than mixed into
   * the link columns above — they are the fine print a visitor goes looking for
   * deliberately, not somewhere the site is inviting them to go.
   */
  legalLinks: FooterLink[] = [
    { label: "FOOTER.LEGAL.PRIVACY", route: "/privacy-policy" },
    { label: "FOOTER.LEGAL.TERMS", route: "/terms-conditions" },
    { label: "FOOTER.LEGAL.COOKIES", route: "/cookies-policy" },
    { label: "FOOTER.LEGAL.PAYMENT", route: "/payment-promotion-policy" },
  ];

  /**
   * Contact block. Everything here comes from BRAND so a new customer edits one
   * config file rather than hunting through the layout — the previous version
   * had the address, the phone number and four social accounts hard-coded here.
   */
  contact = BRAND.contact;

  socials = BRAND.socials;

  hasSocials = BRAND.socials.length > 0;

  readonly demo = DEMO;

  currentDateStr: string = new Date().getFullYear().toString();
  constructor() {}

  scrollToElement(id: string) {
    this.#scrollService.scrollElementById(id);
  }
}
interface FooterLink {
  label: string;
  route: string;
}
interface InfoReusable {
  id?: number;
  element_id?: number;
  name?: string;
  icon?: string;
  url?: string;
  color?: string;
  class?: string;
  is_active?: boolean;
}
interface ContactFooter {
  address: string;
  phone: string;
  email: string;
  facebook: string;
  line: string;
}
